import script from "./DeviceBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceBoard.vue?vue&type=script&setup=true&lang=js"

import "./DeviceBoard.vue?vue&type=style&index=0&id=5a4f3c92&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4f3c92"]])

export default __exports__